export default __webpack_public_path__ + "static/media/phone.841664f8.svg";